import { useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function CarouselRow({ title, subtitle, children, testid }) {
  const ref = useRef(null);
  const drag = useRef({ down: false, startX: 0, scroll: 0, moved: false });
  const [dragging, setDragging] = useState(false);

  const scrollBy = (dir) => {
    if (ref.current) ref.current.scrollBy({ left: dir * (ref.current.clientWidth * 0.8), behavior: "smooth" });
  };

  const onDown = (e) => {
    drag.current = { down: true, startX: e.pageX, scroll: ref.current.scrollLeft, moved: false };
    setDragging(true);
  };
  const onMove = (e) => {
    if (!drag.current.down) return;
    const dx = e.pageX - drag.current.startX;
    if (Math.abs(dx) > 5) drag.current.moved = true;
    ref.current.scrollLeft = drag.current.scroll - dx;
  };
  const onUp = () => { drag.current.down = false; setDragging(false); };

  return (
    <section data-testid={testid} className="relative py-8">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mb-5 flex items-end justify-between">
          <div>
            <h2 className="font-display text-2xl sm:text-3xl font-semibold uppercase tracking-tight text-white">{title}</h2>
            {subtitle && <p className="mt-1 text-sm text-zinc-400">{subtitle}</p>}
          </div>
          <div className="hidden sm:flex gap-2">
            <button aria-label="prev" onClick={() => scrollBy(-1)} className="rounded-full border border-white/15 p-2 text-white hover:border-[#DCA846]/50 hover:text-[#DCA846] transition-colors">
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button aria-label="next" onClick={() => scrollBy(1)} className="rounded-full border border-white/15 p-2 text-white hover:border-[#DCA846]/50 hover:text-[#DCA846] transition-colors">
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
      <div
        ref={ref}
        onMouseDown={onDown}
        onMouseMove={onMove}
        onMouseUp={onUp}
        onMouseLeave={onUp}
        onClickCapture={(e) => { if (drag.current.moved) { e.preventDefault(); e.stopPropagation(); } }}
        className={`no-scrollbar drag-scroll flex gap-5 overflow-x-auto px-4 sm:px-6 pb-2 select-none ${dragging ? "dragging" : ""}`}
      >
        {children}
      </div>
    </section>
  );
}
